import { ReactNode } from 'react';
import { AuthStepWrapper } from './styles';

type AuthStepType = {
  width?: string;
  center?: boolean;
  top?: number;
  children: ReactNode;
};

export const AuthStep = ({ width, center, top, children }: AuthStepType) => {
  return (
    <AuthStepWrapper width={width} center={center} top={top}>
      {children}
    </AuthStepWrapper>
  );
};
